// src/ui/uiHelpers.js
// Shared UI helper functions

import { gameState } from '../game/gameState.js';

/**
 * Update tool upgrade cost color based on current gold
 * @param {string} interfaceSelector - CSS selector for the skill interface (e.g., '.mining-interface')
 */
export function updateToolUpgradeCost(interfaceSelector) {
    const upgradeCostEl = document.querySelector(`${interfaceSelector} .upgrade-cost[data-price]`);
    if (upgradeCostEl) {
        const price = parseInt(upgradeCostEl.dataset.price, 10);
        const currentGold = gameState.getGold();
        const canAfford = currentGold >= price;
        upgradeCostEl.classList.toggle('affordable', canAfford);
        upgradeCostEl.classList.toggle('cant-afford', !canAfford);
    }
}
